import { imageDecodeTransformer, youtubeDecodeTransformer } from './tagTransformers';
import { transformTags } from './transformTags';

export const decodeChangeTags = (html: string, { assetBasePath }: { assetBasePath: string }): string => {
	const { transformer: imageTransformer } = imageDecodeTransformer({ assetBasePath });
	const { transformer: youtubeTransformer } = youtubeDecodeTransformer();

	return transformTags({ html, transformers: [imageTransformer, youtubeTransformer] });
};
